import React, { useState, useEffect } from "react";
import Spinner from "../../../../Shared/Spinner/Spinner";
import { LeftOutlined } from "@ant-design/icons";
import { message, Row, Col, Empty, Button } from "antd";
import { graphql, Query } from "react-apollo";
import {
  GROUPACCESSLIST_QUERY,
  GROUPACCESS_QUERY,
} from "../../../../Apollo/Queries";
import { UPDATEGROUPPERMISSIONS_MUTATION } from "../../../../Apollo/Mutations";
import { avatar } from "../PermissionsBuilder/PermissionFunctions";
import PermissionTable from "../PermissionsBuilder/PermissionTable";
import { Link } from "react-router-dom";
import useGlobal from "../../../../GlobalState/Store";
import Exception from "../../../../Shared/Errors/Exception";

//TODO: Azure Migration DONE - Determine if azureObject should replace pidkey. pidKey state is not used.
const EditGroups = (props) => {
  const [state, setState] = useState({
    pidKey: "",
    permissions: [],
    loading: false,
    superAdmin: false,
  });
  const updatePermissions = (childState, admin) => {
    setState({ ...state, permissions: childState, superAdmin: admin });
  };

  const globalState = useGlobal()[0];
  const { authClaims } = globalState;
  const [adminAccess, setAdminAccess] = useState(false);
  const [hideBtn, sethideBtn] = useState(false);
  //FIXME: Azure Migration DONE - Change from authAccess to authAccesses
  const notAuthorized = (data) => {
    var admin = data.getGroupAccessList.authAccesses.filter(
      (i) => i.ops.id === 11
    );
    if (admin.length > 0 && adminAccess) {
      sethideBtn(true);
      return (
        <PermissionTable
          authAccesses={data.getGroupAccessList.authAccesses}
          edit={true}
          updateParent={updatePermissions}
          heading="New User Permissions Builder"
        />
      );
    } else if (admin.length === 0) {
      sethideBtn(true);
      return (
        <PermissionTable
          authAccesses={data.getGroupAccessList.authAccesses}
          edit={true}
          updateParent={updatePermissions}
          heading="New User Permissions Builder"
        />
      );
    }
    return (
      <div>
        <Exception errorCode={403} message="Not Authorized!" />
      </div>
    );
  };
  useEffect(() => {
    const claim = authClaims.filter((i) => i.ops.id === 11);
    if (claim.length > 0) {
      setAdminAccess(true);
    }
  }, []);

  const onSubmit = () => {
    if (
      (props.match.params.id && state.permissions.length > 0) ||
      state.superAdmin
    ) {
      setState({ ...state, loading: true });
      props
        .mutate({
          variables: {
            var: {
              id: props.match.params.id,
              admin: state.superAdmin,
              userPermissions: state.permissions,
            },
          },
          //TODO: Azure Migration - Determine if Commented Code is needed.
          /* update: (store, { data: { updatePermissions } }) => {
            const User = store.readQuery({ query: USERSACCESS_QUERY });
            User.getUsersWithAccess.filter(
              (i) => i.pidKey === props.match.params.id
            );
            User.getUsersWithAccess.unshift(updatePermissions);
            store.writeQuery({ query: USERSACCESS_QUERY, data: User });
          }, */
          refetchQueries: [
            {
              query: GROUPACCESSLIST_QUERY,
              variables: {
                groupId: props.match.params.id,
              },
            },
            { query: GROUPACCESS_QUERY },
          ],
        })
        .then(({ data }) => {
          setState({ ...state, loading: false });
          props.history.push("/Administration/Permissions");
          message.success(
            `${data.updateGroupPermissions.name} updated successfully!`
          );
        })
        .catch((error) => {
          setState({ ...state, loading: false });
          if (error.networkError) {
            if (error.networkError.result.errors[0].message !== null) {
              message.error(error.networkError.result.errors[0].message);
            }
          } else {
            message.error("An Error occured. Please try again.");
          }
        });
    } else {
      message.info("Please fill out all mandatory fields properly.");
    }
  };

  return (
    <div style={{ padding: "1em", marginBottom: "1em" }}>
      <Spinner loading={state.loading}>
        <Query
          query={GROUPACCESSLIST_QUERY}
          variables={{
            groupId: props.match.params.id,
          }}
        >
          {({ data, loading, error }) => {
            if (loading) {
              return <p style={{ padding: 20 }}>Loading...</p>;
            }
            if (error) return <p>ERROR</p>;
            if (data.getGroupAccessList === null)
              return (
                <>
                  <Row style={{ marginBottom: 100 }} gutter={[8, 24]}>
                    <Col span={24}>
                      <div className="ant-descriptions-title">
                        Edit Permissions
                      </div>
                    </Col>
                  </Row>
                  <Row gutter={[8, 24]}>
                    <Empty />
                  </Row>
                </>
              );
            const {
              getGroupAccessList: { name, description, color },
            } = data;
            return (
              <>
                <Row>
                  <Col span={24}>
                    <div className="ant-descriptions-title">
                      Edit Permissions
                    </div>
                  </Col>
                </Row>
                <Row gutter={[8, 24]}>
                  <Col span={23} offset={1}>
                    {avatar(name, description, color, true)}
                  </Col>
                </Row>
                <Row gutter={[8, 24]}>
                  <Col span={24}>{notAuthorized(data)}</Col>
                </Row>
                <Row>
                  <Col span={12}>
                    <Link to="/Administration/Permissions">
                      <Button type="primary">
                        <LeftOutlined />
                        Go back
                      </Button>
                    </Link>
                  </Col>
                  {hideBtn ? (
                    <Col span={12}>
                      <Button
                        onClick={onSubmit}
                        style={{ float: "right" }}
                        type="primary"
                      >
                        Submit
                      </Button>
                    </Col>
                  ) : null}
                </Row>
              </>
            );
          }}
        </Query>
      </Spinner>
    </div>
  );
};

const EditGroup = graphql(UPDATEGROUPPERMISSIONS_MUTATION)(EditGroups);

export default EditGroup;
